import { OTPDialogTrackingPoint } from '@shopee-user/tracking-constants';

import { PageType } from '../constants';

const OTPDialogTrackingSchema: Record<OTPDialogTrackingPoint, string> = {
  [OTPDialogTrackingPoint.OTPDialogPopupImpression]:
    '628717d4-d707-4460-a687-b576604976e0',
  [OTPDialogTrackingPoint.OTPDialogPopupConfirmButtonClick]:
    '48cebe32-8b8b-4bbf-9654-d8d454e85784',
};

export const getOTPDialogPageTypeAndSchema = (
  trackingPoint: OTPDialogTrackingPoint
) => {
  return {
    page_type: PageType.OTPDialogPopup,
    schema: OTPDialogTrackingSchema[trackingPoint],
  };
};
